import Tabs from "../../../../components/common/Tabs";
import { tuitionAdminDetailsTabsData } from "../../../../config/tabsConfig";

interface DetailsTabsContainerProps {
  applicationData: any;
  documentsRefreshTrigger?: number;
}

const DetailsTabsContainer = ({
  applicationData,
  documentsRefreshTrigger,
}: DetailsTabsContainerProps) => {
  if (!applicationData) {
    return null;
  }

  const { firstname,middleName,lastname, applicationId, unionId, unionName, applDate } = applicationData;
  return (
    <div >
      <h1 className="h3 mb-5! !mt-[96px]">
        {firstname} {middleName} {lastname} - Application ID : <span className="text-[#006BA6]">{applicationId}</span> - {applDate} - Union ID : {unionId} - {unionName}
      </h1>
    
  <Tabs tabs={tuitionAdminDetailsTabsData} extraProps={{ applicationData, documentsRefreshTrigger ,applicationId}} />
    </div>
  );
};

export default DetailsTabsContainer;
